<template>
  <div class="common-header">
    <header>
        <div class="header-container">
          <div class="header-logo"><img src="../../static/img/logo.png" alt="" title="" width="100%;"/></div>
           <ul>
               <li v-for="(item,index) in navList" v-on:click="changeLanguage(index)">
                 <div v-if="curNavIndex === item.curIndex" :class="{current:true}">
                   <router-link :to="item.linkUrl">
                     {{item.text}}
                   </router-link>
                 </div>
                 <div v-else :class="{current:false}">
                   <router-link :to="item.linkUrl">
                     {{item.text}}
                   </router-link>
                 </div>
               </li>
           </ul>
        </div>
    </header>
  </div>
</template>
<script>
  import axios from 'axios';
  import {API_LIST} from '../utils/config';
  import { setLanguage, getLanguage} from '../utils/language';
  import { getBrowser} from '../utils/browser';

export default {
  name: 'common-header',
  data () {
    return {
      navList: []
    }
  },
  props:['curNavIndex'],
  methods: {
    getBaseInfo: function(curLanguage = '',curChangeFlag = false){
      var formData = JSON.stringify({language: curLanguage, changeFlag: curChangeFlag});

      axios.post(API_LIST.baseInfo, JSON.parse(formData))
        .then(function(res) {
          if (res.data.status.error_code === 0) {
            baseInfoObj = res.data.bizobj;

            this.navList = [
              {text: baseInfoObj.painters, linkUrl:'/', curIndex: 0},
              {text: baseInfoObj.works, linkUrl:'/works/_', curIndex: 1},
              {text: baseInfoObj.gallery, linkUrl:'/about', curIndex: 2},
              {text: baseInfoObj.showLanguage, linkUrl:'', curIndex: 3}
            ]

            $('#J_SearchPlaceholder').attr('placeholder',baseInfoObj.keywords);
            $('#J_CopyRight').text(baseInfoObj.copyright);
            $('#J_LawLink').attr('href',baseInfoObj.lawLink);
            $('#J_LawLink').text(baseInfoObj.lawText);

            setLanguage(baseInfoObj.urlLanguage);

            if(curChangeFlag){
              if(window.location.href.indexOf('/#/works/') > -1){
                if($.trim($('#J_SearchPlaceholder').val()) === ''){
                  window.location.href = '/#/works/_' + new Date().getTime();
                }else{
                  window.location.href = '/#/works/' + $.trim($('#J_SearchPlaceholder').val()) + '_' + new Date().getTime();
                }
              }

              if(window.location.href.indexOf('/#/workDetail/') > -1 || window.location.href.indexOf('/#/painterDetail/') > -1){
                window.location.reload();
              }
            }
          }
        }.bind(this))
        .catch(function(err) {
          console.log(err);
        });
    },
    changeLanguage: function(curIndex){
      if(curIndex === 3){
        this.getBaseInfo(getLanguage(), true);
      }
    }
  },
  created: function(){
    if(!getBrowser()){
      window.location.href = API_LIST.pcLinkUrl;
    }else{
      let navLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();

      if(navLanguage.split('-')[0] === 'zh'){
        navLanguage = 'en';
      }else{
        navLanguage = 'zh';
      }

      let curLanguage = getLanguage() !== undefined ?  getLanguage() : navLanguage;

      this.getBaseInfo(curLanguage, false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?43c8becc